// src/components/FormSection/FormSection.js
import React, { useState } from 'react';
import Invoices         from './Invoices';
import SupplierForm     from './SupplierForm';
import ExpenseForm      from './ExpenseForm';
// import AdvanceRequest   from './AdvanceRequest'; // ⬅️ Gerekirse yorum satırı yapabilirsin
import './FormSection.css';

const FormSection = () => {
  // Kullanıcı bilgisini al
  const user = JSON.parse(sessionStorage.getItem('user') || '{}');
  const isAdmin = user.role === 'admin';
  const isManager = user.role === 'manager';

  // Tab listesini rol bazlı oluştur
  const tabs = [];
  if (isAdmin || isManager) {
    tabs.push({ label: 'Faturalar',      component: <Invoices /> });
    tabs.push({ label: 'Tedarikçi Formu', component: <SupplierForm /> });
  }
  // Masraf formu herkesin erişebileceği sekme
  tabs.push({ label: 'Masraf Formu',     component: <ExpenseForm /> });

  const [activeTab, setActiveTab] = useState( tabs.length > 0 ? 0 : -1 );

  return (
    <div className="form-section">
      <div className="tabs">
        {tabs.map((tab, idx) => (
          <div
            key={idx}
            className={`tab ${activeTab === idx ? 'active' : ''}`}
            onClick={() => setActiveTab(idx)}
          >
            {tab.label}
          </div>
        ))}
      </div>

      <div className="tab-content">
        { activeTab >= 0
          ? tabs[activeTab].component
          : <p>Görüntülenecek form yok.</p>
        }
      </div>
    </div>
  );
};

export default FormSection;
